const initialState = {
  services: [],
  error: "",
};

export default initialState;
